<template>
    <div class="template tableStyle">
        <el-form :model="form" :rules="rules" label-width="auto">
            <el-form-item label="模板名称：" prop="name">
                <el-input v-model="form.name" placeholder="请输入模板名称" style="width: 390px"></el-input>
            </el-form-item>
            <el-form-item label="发货地址：" prop="address">
                <el-cascader v-model="form.area" :options="areaOptions" @change="areaChange"  style="width: 390px"></el-cascader>
            </el-form-item>
            <el-form-item label="发货时间：" prop="time">
                <el-input v-model="form.time" placeholder="请输入发货时间，例：24小时/3天/7天" style="width: 390px"></el-input>
            </el-form-item>
            <el-form-item label="是否包邮：" prop="isFree">
                <el-radio-group v-model="form.isFree">
                    <el-radio :label="1">买家承担运费</el-radio>
                    <el-radio :label="0">卖家承担运费</el-radio>
                </el-radio-group>
            </el-form-item>
            <el-form-item label="计价方式：">
                按重量
            </el-form-item>
            <el-form-item label="运送方式：">
                除指定地区外，其余地区的运费采用“默认运费”
            </el-form-item>
            <el-form-item>
                <el-checkbox v-model="form.deliveryMode === 'express'">快递</el-checkbox>
            </el-form-item>

            <el-form-item prop="defaultInfo">
                <div class="settingWrap">
                    <div class="defaultsetting">
                        默认运费：<el-input v-model="form.defaultInfo.initWeight">
                        </el-input>kg内，<el-input v-model="form.defaultInfo.initPrice">
                        </el-input>元，每增加<el-input v-model="form.defaultInfo.addWeight">
                        </el-input>kg，增加运费<el-input v-model="form.defaultInfo.addPrice">
                        </el-input>元
                    </div>

                    <div class="settingTable">
                        <el-table :data="tableList" style="width: 100%" border>
                            <el-table-column label="运送到" align="center">
                                <template slot-scope="scope">
                                    <span v-if="scope.row.province.length != 0" style="margin-right: 15px;">
                                        {{scope.row.province.join('、')}}
                                    </span>
                                    <el-link :underline="false" type="primary" @click="openDialog(scope.$index)">编辑</el-link>
                                </template>
                            </el-table-column>
                            <el-table-column label="首重（kg）" width="100" align="cetner">
                                <template slot-scope="scope">
                                    <el-input v-model="scope.row.initWeight" class="tableInput"></el-input>
                                </template>
                            </el-table-column>
                            <el-table-column label="首费（元）" width="100" align="cetner">
                                <template slot-scope="scope">
                                    <el-input v-model="scope.row.initPrice" class="tableInput"></el-input>
                                </template>
                            </el-table-column>
                            <el-table-column label="续重（kg）" width="100" align="cetner">
                                <template slot-scope="scope">
                                    <el-input v-model="scope.row.addWeight" class="tableInput"></el-input>
                                </template>
                            </el-table-column>
                            <el-table-column label="续费（元）" width="100" align="cetner">
                                <template slot-scope="scope">
                                    <el-input v-model="scope.row.addPrice" class="tableInput"></el-input>
                                </template>
                            </el-table-column>
                            <el-table-column label="操作" width="100" align="cetner">
                                <template slot-scope="scope">
                                    <el-link :underline="false" type="primary" @click="delTableItem(scope.$index)">删除</el-link>
                                </template>
                            </el-table-column>
                        </el-table>
                        <div class="addBtn">
                            <el-button style="width: 100%; border-radius: 0;" @click="addTableItem">
                                <i class="el-icon-plus"></i>
                                新增
                            </el-button>
                        </div>
                        
                    </div>
                </div>
            </el-form-item>
        </el-form>
        <div class="fcBtn">
            <el-button type="primary" @click="save">保存</el-button>
        </div>

        <el-dialog
            title="提示"
            :visible.sync="dialogShow"
            width="30%"
            :before-close="closeDialog">
            <el-checkbox-group v-model="checkList">
                <el-checkbox v-for="(item, index) in provinceList" :key="index" :label="item">{{item}}</el-checkbox>
            </el-checkbox-group>
            <span slot="footer" class="dialog-footer">
                <el-button @click="closeDialog">取 消</el-button>
                <el-button type="primary" @click="confirm">确 定</el-button>
            </span>
        </el-dialog>
    </div>
</template>
<script>
import { regionData, CodeToText } from "element-china-area-data";
export default {
    data() {
        return {
            areaOptions: regionData,
            area: [],
            provinceList: [
                '北京',
                '天津',
                '河北',
                '山西',
                '内蒙古',
                '黑龙江',
                '吉林',
                '辽宁',
                '上海',
                '江苏',
                '浙江',
                '安徽',
                '福建',
                '江西',
                '山东',
                '河南',
                '湖北',
                '湖南',
                '广东',
                '广西',
                '海南',
                '重庆',
                '四川',
                '贵州',
                '云南',
                '西藏',
                '陕西',
                '甘肃',
                '青海',
                '宁夏',
                '新疆',
                '台湾',                
                '香港',
                '澳门'
            ],
            tableList: [
                {
                    province: [],
                    initWeight: '',
                    initPrice: '',
                    addWeight: '',
                    addPrice: '',
                }
            ],
            dialogShow: false,
            checkList: [],
            currentEditIndex: null,
            form:{
                name: '',
                address: '',
                time: '',
                isFree: 1,
                calcMode: 'weight',
                deliveryMode: 'express',
                defaultInfo: {
                    initWeight: '',
                    initPrice: '',
                    addWeight: '',
                    addPrice: '',
                }
            },
            rules: {
                name: [{required: true, message: '请输入模板名称', trigger: 'blur'}],
                address: [{required: true, message: '请选择发货地址', trigger: 'blur'}],
                time: [{required: true, message: '请输入发货时间', trigger: 'blur'}],
                isFree: [{required: true, message: '请选择是否包邮', trigger: 'blur'}],
                deliveryMode: [{required: true, message: '', trigger: 'blur'}],
                defaultInfo: [{required: true, message: '请填写默认运费', trigger: 'blur'}]
            }
        }
    },
    methods: {
        areaChange(){
            
        },
        addTableItem(){
            this.tableList.push({
                province: [],
                initWeight: '',
                initPrice: '',
                addWeight: '',
                addPrice: '',
            });
        },
        delTableItem(index){
            console.log(index);
            if(this.tableList.length === 1){
                return;
            }else{
                this.tableList.splice(index, 1);
            }
        },
        save(){
            window.close();
            history.back();
        },
        openDialog(index){
            if(this.tableList[index].province.length != 0){
                this.checkList = this.tableList[index].province;
            }

            this.currentEditIndex = index;
            this.dialogShow = true;
        },
        closeDialog(){
            this.dialogShow = false;
            this.checkList = [];
            this.currentEditIndex = null;
        },
        confirm(){
            let index = this.currentEditIndex;
            this.tableList[index].province = this.checkList;
            this.closeDialog();
        },
    },
}
</script>
<style lang="less" scoped>
    /deep/.el-table th.el-table__cell{
        background-color: #F4F5F7;
    }
    .template{
        padding-left: 60px;
        padding-top: 20px;
        background: #fff;
        padding-bottom: 30px;
        height: 100%;
        overflow-y: scroll;
        .settingWrap{
            padding: 20px;
            width: 900px;
            border: 1px solid #ebebeb;

            .defaultsetting{
                margin-bottom: 20px;
                padding: 0 20px;
                height: 55px;
                line-height: 55px;
                background-color: #F2F9FF;
                font-size: 14px;
                color: #333;

                /deep/.el-input{
                    margin: 0 10px;
                    width: 88px;
                    .el-input__inner{
                        height: 30px;
                    }
                }
            }

            .settingTable{
                .addBtn{
                    width: calc(100% - 0px);
                    height: 39px;
                    text-align: center;
                    // border: 1px solid #ebebeb;
                    // border-top: none;
                    color: #0C78D7;
                    cursor: pointer;

                    i{
                        font-weight: bold;
                    }
                }
                /deep/.el-table .el-table__cell{
                    padding: 8px 0 !important;
                }
                .tableInput{
                    /deep/.el-input__inner{
                        height: 24px;
                    }
                }
            }
        }
        .fcBtn{
            text-align: center;
        }
    }
</style>